import {isIE9, isIE10, isIE11} from './iebrowsertests.js'
import browserWidth from './browserwidth.js'
import equaliseRowsAndAfterImagesLoad from './equaliserowsandafterimagesload.js'
import matchImageDimensions from './match-image-dimensions.js'

export default function () {
  // IE9 and IE10 need some elements' heights set to retain grid
  if (!Modernizr.flexbox || isIE9 || isIE10) {
    // General case: CSS helper class
    equaliseRowsAndAfterImagesLoad('.js-equalize-heights-fallback')
    // Homepage: Grid of winners. The top bar with either 'Worlds best…' or the position number
    equaliseRowsAndAfterImagesLoad('.card-airlines .rounded-top')
    equaliseRowsAndAfterImagesLoad('.card-airlines')
    // Homepage: Other winners components
    equaliseRowsAndAfterImagesLoad('.card-other-winner .background--light-grey')
    // Homepage: The latest headlines
    equaliseRowsAndAfterImagesLoad('.articles-carousel__photo + .card-body.background--light-blue')
    // News items
    equaliseRowsAndAfterImagesLoad('.card-news .card-body')
    // Homepage latest headlines
    equaliseRowsAndAfterImagesLoad('.card-link .card-body')
    // Testimonials on testimonials page
    equaliseRowsAndAfterImagesLoad('.testimonial-container .card')
    equaliseRowsAndAfterImagesLoad('.testimonial-container > div')
    // Search result items
    equaliseRowsAndAfterImagesLoad('.search-result-items .card.card-news')
  }

  if (!Modernizr.flexbox || isIE9 || isIE10 || isIE11) {
    // Homepage latest news
    equaliseRowsAndAfterImagesLoad('.card.background--light-blue')
  }

  if (isIE9 || isIE10) {
    // Homepage: position the name-text in the winners section items
    $('.card-airlines h3').css({'position': 'absolute', 'left': '0.5em', 'right': '0.5em', 'bottom': '0.5em'})
    $('.card-airlines h4').css({'position': 'absolute', 'left': '0.5em', 'right': '0.5em', 'bottom': '0.5em'})
    // Related articles near the footer
    $('.card-default .text-responsive-h4').css({'position': 'absolute', 'left': '0.5em', 'right': '0.5em', 'bottom': '0.5em'})
  }

  if (isIE9 || isIE10) {
    // First pass attempt to center some one-line components that are centred by flexbox in supporting browsers
    $('.row.justify-content-md-center .col-lg-8').addClass('mx-auto float-none')
    $('.row.justify-content-md-center .col-md-8').addClass('mx-auto float-none')
    // $('.row.justify-content-md-center .col-lg-8.text-center').addClass('mx-auto float-none')
    $('.row.justify-content-md-center .col-lg-6.text-center').addClass('mx-auto float-none')
  }

  // Vertically centering the H1s in the hero areas
  if ((isIE9 || isIE10) && browserWidth() > 1026) {
    $('.herobanner__inner h1, .herobanner__inner .text-responsive-h1').css({'margin-top': '3rem'})
  }

  // Size the logos all the same height depending on the width of the image.
  if (!Modernizr.flexbox || isIE9 || isIE10 || isIE11) {
    matchImageDimensions({
      sizeImages: '.awards-list__logocontainer--mobiledouble',
      compareImages: '.awards-list__photocontainer--mobiledouble'
    })
    matchImageDimensions({
      sizeImages: '.awards-list__logocontainer--double',
      compareImages: '.awards-list__photocontainer--double'
    })
  }
}
